/**
 * Automatic trim variant parameter generation for design materials.
 * @module
 */
import { MasonryTrimKind } from "common/materials/masonryTypes";
import type { DesignMaterialParams } from "./designMaterialTypes";

export function generateMaterialTrimVariant(params: DesignMaterialParams, trim: MasonryTrimKind): DesignMaterialParams {
  const targetParams: DesignMaterialParams = JSON.parse(JSON.stringify(params));
  targetParams.sdf.patterns[0].enabled = true;
  targetParams.sdf.patterns[1].enabled = true;
  targetParams.sdf.patterns[2].enabled = false;
  targetParams.sdf.patterns[3].enabled = false;

  const singleRowDistance =
    params.sdf.patterns[0].yDistance / Math.floor(params.sdf.patterns[0].yDistance / params.sdf.patterns[0].ySize);

  // We set the patterns to be continuous - 40 is an arbitrary value.
  const continuousSize = 40;

  if (trim === MasonryTrimKind.Rowlock) {
    targetParams.sdf.patterns[0].xSize = params.sdf.patterns[0].ySize;
    targetParams.sdf.patterns[1].xSize = params.sdf.patterns[0].ySize;
    targetParams.sdf.patterns[0].xDistance = singleRowDistance * 2;
    targetParams.sdf.patterns[1].xDistance = singleRowDistance * 2;

    targetParams.sdf.patterns[0].ySize = continuousSize;
    targetParams.sdf.patterns[1].ySize = continuousSize;
    targetParams.sdf.patterns[0].yDistance = continuousSize;
    targetParams.sdf.patterns[1].yDistance = continuousSize;

    targetParams.sdf.patterns[0].bevelDistanceX = 0;
    targetParams.sdf.patterns[1].bevelDistanceX = 0;
    targetParams.sdf.patterns[0].bevelDistanceZ = 0;
    targetParams.sdf.patterns[1].bevelDistanceZ = 0;
    targetParams.sdf.patterns[0].xOffset = 0;
    targetParams.sdf.patterns[1].xOffset = singleRowDistance;
    targetParams.sdf.patterns[0].yOffset = 0;
    targetParams.sdf.patterns[1].yOffset = 0;
    targetParams.sdf.patterns[1].varyHeight = false;
  } else if (trim === MasonryTrimKind.Header) {
    targetParams.rotateAllLayers = params.rotateAllLayers + 90;
    targetParams.sdf.patterns[0].rotation = 90;
    targetParams.sdf.patterns[1].rotation = 90;
    targetParams.sdf.patterns[0].xSize = params.sdf.patterns[0].ySize;
    targetParams.sdf.patterns[1].xSize = params.sdf.patterns[0].ySize;
    targetParams.sdf.patterns[0].xDistance = singleRowDistance * 2;
    targetParams.sdf.patterns[1].xDistance = singleRowDistance * 2;
    targetParams.sdf.patterns[0].ySize = continuousSize;
    targetParams.sdf.patterns[1].ySize = continuousSize;
    targetParams.sdf.patterns[0].yDistance = continuousSize;
    targetParams.sdf.patterns[1].yDistance = continuousSize;
    targetParams.sdf.patterns[0].bevelDistanceX = 0;
    targetParams.sdf.patterns[1].bevelDistanceX = 0;
    targetParams.sdf.patterns[0].bevelDistanceZ = 0;
    targetParams.sdf.patterns[1].bevelDistanceZ = 0;
    targetParams.sdf.patterns[0].xOffset = 0;
    targetParams.sdf.patterns[1].xOffset = singleRowDistance;
    targetParams.sdf.patterns[0].yOffset = 0;
    targetParams.sdf.patterns[1].yOffset = 0;
    targetParams.sdf.patterns[1].varyHeight = false;
  }
  return targetParams;
}
